export default __webpack_public_path__ + "static/media/ssl2.3c9607fd.svg";